import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";
import { FETCH_PRODUCT_LINES } from "./graphql";
import ProductLineView from "./ProductLineView";

const BizBeautyshots = () => {
  const [searchText, setSearchText] = useState("");

  const { loading, error, data } = useQuery(FETCH_PRODUCT_LINES, {
    variables: {
      hasActiveProducts: true,
    },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const lines = data.productLines.results.filter((i) =>
    searchByProp(i, ["name"], searchText),
  );

  return (
    <div>
      <div className="m-6">
        <div className="opacity-70 space-y-2">
          <p>
            Please prepare the beautyshots in SharePoint (
            <a
              href="https://wabobaadmin.sharepoint.com/sites/Waboba/Shared%20Documents/wis/beautyshots/biz/"
              target="_blank"
              rel="noreferer"
              className="mx-1"
            >
              Waboba / Documents / wis / beautyshots / biz
            </a>
            ) first.
          </p>
          <p>Click the sync button below each product to submit to WIS.</p>
        </div>
      </div>

      {/* search bar */}
      <div className="mx-6 flex items-center">
        <div className="flex-1">
          <SearchBar
            value={searchText}
            onChange={setSearchText}
            placeholder="Search by Name."
          />
        </div>
      </div>

      <div>
        {lines.map((i, index) => (
          <ProductLineView productLine={i} key={index} stage={"biz"} />
        ))}
      </div>
    </div>
  );
};

export default BizBeautyshots;
